import React from 'react'
import heroImage from '../../static/phone.png'
import { Link } from 'wouter'
import { useSelector } from 'react-redux'

import {
  HeroContainer,
  HeroContent,
  Title,
  Subtitle,
  HeroButton,
  ImageContainer,
  ImageItem
} from './elements'

const Hero = () => {

  const { userInfo } = useSelector(state => state.userLogin)

  return (
    <HeroContainer>
      <HeroContent>
        <Title>A place to find ideas, business, projects, jobs, share knowledge and opinions</Title>
        <Subtitle>Feel free to write what you think or want</Subtitle>
        {!userInfo &&
          <HeroButton primary>
            <Link to={`/blog/registrarse`}>
              Join us?
            </Link>
          </HeroButton>
        }
      </HeroContent>
      {/* <ImageContainer>
        <ImageItem src={heroImage} alt="Hero Image" />
      </ImageContainer> */}
    </HeroContainer>
  )
}

export default Hero
